import { IAddress } from 'models';
import { apiVersion } from './apis.const';
import { transformResponse } from './apis.util';
import { baseApi } from './base.api';

/**
 * API Urls
 */
const orgUrl = `/${apiVersion}/organizations`;
// const orgIdUrl = ({ id }: { id: number }) => `/${apiVersion}/organizations/${id}`;
const orgRegisterUrl = `/${apiVersion}/organizations/register`;
// const orgUserDeleteUrl = ({ orgId, userId }: { orgId: number; userId: number }) =>
//   `/${apiVersion}/organizations/${orgId}/delete-user/${userId}`;
const userOrgUrl = ({ orgSlug }: { orgSlug: string }) => `/${orgSlug}/${apiVersion}/organizations`;
const userOrgLogoUrl = ({ orgSlug }: { orgSlug: string }) => `/${orgSlug}/${apiVersion}/organizations/logo`;
const userOrgInviteUrl = ({ orgSlug }: { orgSlug: string }) => `/${orgSlug}/${apiVersion}/organizations/invite`;
const userOrgBillingAddressUrl = ({ orgSlug }: { orgSlug: string }) =>
  `/${orgSlug}/${apiVersion}/payment-methods/billing-addresses`;

/**
 * Create APIs
 */
export const orgApi = baseApi.injectEndpoints({
  overrideExisting: false,

  endpoints: (build) => ({
    fetchOrgs: build.query<FetchOrgsRes, FetchOrgsReq>({
      query: () => ({
        url: orgUrl,
      }),
      transformResponse,
    }),

    createOrg: build.mutation<CreateOrgRes, CreateOrgReq>({
      query: ({ org }) => ({
        url: orgRegisterUrl,
        method: 'POST',
        body: org,
      }),
      transformResponse,
    }),

    updateOrg: build.mutation<UpdateOrgRes, UpdateOrgReq>({
      query: ({ orgSlug, data }) => ({
        url: userOrgUrl({ orgSlug }),
        method: 'PUT',
        body: data,
      }),
      transformResponse,
      invalidatesTags: ['CurrentUser'],
    }),

    addOrgThumbnail: build.mutation<AddOrgThumbnailRes, AddOrgThumbnailReq>({
      query: ({ orgSlug, data }) => ({
        url: userOrgLogoUrl({ orgSlug }),
        method: 'POST',
        body: data,
      }),
      transformResponse,
    }),

    updateOrgBilingAddress: build.mutation<UpdateOrgBilingAddressRes, UpdateOrgBilingAddressReq>({
      query: ({ orgSlug, billing_address, shipping_address }) => ({
        url: userOrgBillingAddressUrl({ orgSlug }),
        method: 'PUT',
        body: {
          billing_address,
          shipping_address,
        },
      }),
      transformResponse,
      invalidatesTags: ['CurrentUser'],
    }),

    inviteUsers: build.mutation<InviteUserRes, InviteUserReq>({
      query: ({ orgSlug, data }) => ({
        url: userOrgInviteUrl({ orgSlug }),
        method: 'POST',
        body: data,
      }),
      transformResponse,
    }),
  }),
});

/**
 * Hooks
 */
export const {
  useFetchOrgsQuery,
  useCreateOrgMutation,
  useUpdateOrgMutation,
  useAddOrgThumbnailMutation,
  useUpdateOrgBilingAddressMutation,
  useInviteUsersMutation,
} = orgApi;

/**
 * Types
 */
type FetchOrgsRes = any;
type FetchOrgsReq = void;
type CreateOrgRes = any;
type CreateOrgReq = {
  org: any;
};
type UpdateOrgRes = any;
type UpdateOrgReq = {
  orgSlug: string;
  data: any;
};
type AddOrgThumbnailRes = any;
type AddOrgThumbnailReq = {
  orgSlug: string;
  data: FormData;
};
type UpdateOrgBilingAddressRes = any;
type UpdateOrgBilingAddressReq = {
  orgSlug: string;
  billing_address: IAddress | null;
  shipping_address: IAddress | null;
};
type InviteUserRes = any;
type InviteUserReq = {
  orgSlug: string;
  data: any;
};
